import styled from 'styled-components';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userId from '../../../shared/helpers/userId';
import Hero from './hero';
import Header from './header';
import Breadcrumbs from './breadcrumbs';
import ProgramTabs from './programTabs';
import SkipLink from './structure/SkipLink';
import LearnMoreModal from './modals/learnMore';
import FavoriteProgramModal from './modals/favoriteProgramModal';
import LoadingScreen from '../../../styledComponents/styles/LoadingScreen';

import MobileTabs from './programTabs/MobileTabs';
import AcademicsTab from './programTabs/academics';
import ResourcesTab from './programTabs/resources';
import EligibilityTab from './programTabs/eligibility';
import AboutProgramTab from './programTabs/aboutProgram';
import WhatsIncludedTab from './programTabs/whatsIncluded';
import CostAndFundingTab from './programTabs/costAndFunding';
import ProgramOverviewTab from './programTabs/programOverview';
import TermInformationTab from './programTabs/termInformation';

import history from '../../../history';
import { breakpoints } from '../utils/breakpoints';
import checkTabNotEmpty from '../utils/checkTabNotEmpty';
import { getProgram, getProgramBrochure } from '../../../actions/programBrochure';
import { getProgramImages } from '../../../actions/programModifyActions';
import { toggleFavorite } from '../../../actions/programBrochureActions';
import programBrochureTabs from '../utils/programBrochureTabs';
import { getCurrentUser } from '../../travelerProfile/actions/travelerProfileActions';
import BlockPage from './blockPage';
import UserPilotScript from '../../../components/UserPilotScript';
import ScreenReaderText from '../../travelerProfile/components/base/ScreenReaderText.styled';
import ImageCaraousel from './ImageCaraousel';
import { CarouselMainIcons } from '../../../styledComponents/styles/IconCustom.styled';
import { hasProgramFeatureAccessPermission } from '../../../helpers/CommonHelper';

const MainContainer = styled.div`
  padding: 0.70125rem 2.23125rem 0.70125rem 2.23125rem;
  background-color: var(--theme_color_dark);
  @media only screen and (min-width: 280px) and (max-width: 430px) {
    padding: 0.70125rem 1.2rem 0.70125rem 1.2rem;
  }
`;
const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 60.375rem;
  margin: 0 auto;
  padding: 0 0.75rem;

  @media ${breakpoints.desktop} {
    padding: 0;
  }
`;

const InnerMainContainer = styled.main`
  background-color: #ffffff;
`;

const CarouselContainer = styled.div`
  max-width: 65.375rem;
  margin: 15px auto;
`
const HeroContainer = styled.div`
  max-width: 65.375rem;
  margin: 15px auto;
`

const TitleContainer = styled.div`
  max-width: 60.375rem;
  margin: auto;
  padding: 24px 15px 15px 55px;
  color: var(--black, #373737);
  font-family: Nunito;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 43.2px */
  word-break: break-word;

  @media (max-width: 768px) {
    padding: 20px 15px 15px 20px; /* Mobile padding */
  }
`


export default function Brochure({ program_id, tab }) {
  const dispatch = useDispatch();
  const titleRef = useRef();
  const programId = Number(program_id);
  const [currentTab, setCurrentTab] = useState({
    title: 'Program Overview',
    path: '',
    component: 'programOverview',
  });
  const program = useSelector(state => state.programBrochure);
  const currentUserData = useSelector(state => state.profile.currentUser);
  const { clientFeatureList } = useSelector(state => state.profile);
  const { showLearnMoreModal: isLearnMoreModalOpen } = useSelector(state => state.programBrochure);
  const { 'is_traveler?': isTraveler, admin_sign_in: isAdmin } = useSelector(state => state.profile.currentUser);
  const programAlias = useSelector(state => state.auth.organization.info.alias_program);
  const programImages = useSelector(state => state.programModify.programImages);
  const userProfile = useSelector(state => state.profile);
  const favoriteDisclaimerUpdated = useSelector(state => state.programBrochure.update_favorite_disclaimer);
  const [isLoading, setIsLoading] = useState(false);
  const [showFavoriteModal, setShowFavoriteModal] = useState(false);
  const [activeTabs, setActiveTabs] = useState(programBrochureTabs(programAlias));
  const clientAccountId = useSelector(state => state.auth.organization.id);
  const currentOrganization = useSelector(state => state.auth);

  const { hasPremiumAccess } = hasProgramFeatureAccessPermission(program.meta.authorized, program.meta.premium_program_feature_access, clientFeatureList?.premium_program_feature_access || currentOrganization?.clientFeatureList?.premium_program_feature_access, program.meta.primaryClientAccountId, clientAccountId)

  
  const componentMap = {
    academics: AcademicsTab,
    resources: ResourcesTab,
    eligibility: EligibilityTab,
    aboutProgram: AboutProgramTab,
    whatsIncluded: WhatsIncludedTab,
    costAndFunding: CostAndFundingTab,
    programOverview: ProgramOverviewTab,
    termInformation: TermInformationTab,
  };
  const Component = componentMap[currentTab.component];

  const componentTitles = {
    academics: 'Academics Tab',
    resources: 'Resources Tab',
    eligibility: 'Eligibility Tab',
    aboutProgram: 'About Program Tab',
    whatsIncluded: 'Whats Included Tab',
    costAndFunding: 'Cost And Funding Tab',
    programOverview: 'Program Overview Tab',
    termInformation: 'Term Information Tab',
  };

  const componentTitle = componentTitles[currentTab.component];

  const getNonEmptyTabs = () => {
    const nonEmptyTabs = ['programOverview'];
    let tabs = programBrochureTabs(programAlias, program.program_tabs);
    const isVisitor = !isTraveler && !isAdmin;

    if (isVisitor) {
      tabs = tabs.filter(tab => tab.component !== 'resources');
    }

    tabs.forEach(tab => {
      const tabIsNotEmpty = checkTabNotEmpty(program, tab.component);

      if (tabIsNotEmpty) {
        nonEmptyTabs.push(tab.component);
      }
    });

    const activeTabLists = tabs.filter(tab => nonEmptyTabs.includes(tab.component));
    
    if(hasPremiumAccess === false){
      const premiumAccessTabs = ['whatsIncluded','resources'];
      const filteredTabList = activeTabLists.filter(
        (tab) => !premiumAccessTabs.includes(tab.component)
      );
      setActiveTabs(filteredTabList);
    } else {
      setActiveTabs(activeTabLists);
    }
    
  };

  useEffect(() => {
    let unmounted = false;
    setIsLoading(true);
    if (!unmounted) {
      
      if (isTraveler && !isAdmin) {
        // dispatch(getProgram(programId, 'traveler'));
        dispatch(getProgramImages(programId, 'traveler'));
        dispatch(getProgramBrochure(programId, 'traveler'));   
      } else if (isAdmin) {
        !window.location.href.includes('/client/')
          ? window.location.assign(`/client/program_brochure/${program_id}`)
          : null;
        // dispatch(getProgram(programId, 'client'));
        dispatch(getProgramImages(programId, 'client'));
        dispatch(getProgramBrochure(programId, 'client'));  
      } else if (!userId) {
        // dispatch(getProgram(programId, 'visitor'));
        dispatch(getProgramImages(programId, 'visitor'));
        dispatch(getProgramBrochure(programId, 'visitor')); 
      }
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => {
      unmounted = true;
    };
  }, [currentUserData, programId]);

  useEffect(() => {
    !program.loading ? getNonEmptyTabs() : null;
  }, [program]);

  useEffect(() => {
    window.scrollTo(0, localStorage.getItem('scrollY') || 0);

    const currentTab = activeTabs.find(brochureTab => brochureTab.path === (tab || ''));

    if (!currentTab) {
      history.push(`/not_found`);
    }

    setCurrentTab(activeTabs.find(brochureTab => brochureTab.path === (tab || '')));
  }, [tab]);

  const submitFavourite = () => {
    const isFavDisAccepted = true;
    dispatch(toggleFavorite(programId, userProfile.currentUser.id, isFavDisAccepted));
    //Add update user API here
  };

  useEffect(() => {
    if (favoriteDisclaimerUpdated) {
      dispatch(getCurrentUser(userProfile.currentUser.id));
    }
  }, [favoriteDisclaimerUpdated]);

  const getFavoriteDetails = () => {
    if (!showFavoriteModal) {
      setShowFavoriteModal(!showFavoriteModal);
    }
  };

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, []);

  return (
    <>
      <UserPilotScript />
      {isLoading ? (
        <LoadingScreen displayText="Loading..." />
      ) : (
        <>
          {!isAdmin && (program.publishStatus === 'unpublished' || program.publishStatus === 'deleted') ? (
            <>
              <BlockPage />
            </>
          ) : (
            <MainContainer>
              {!isLoading && (
                <>
                  <ScreenReaderText ref={titleRef} tabIndex={-1}>
                    {componentTitle}
                  </ScreenReaderText>
                  {/* <SkipLink /> */}
                  {isLearnMoreModalOpen && <LearnMoreModal />}
                  {showFavoriteModal && (
                    <FavoriteProgramModal
                      show={showFavoriteModal}
                      onSubmit={() => submitFavourite()}
                      onClose={() => setShowFavoriteModal(!showFavoriteModal)}
                    />
                  )}
                  <Header
                    programId={programId}
                    programTitle={program.meta.title}
                    programBrochureSection={program.program_brochure_section}
                    toggleFavoriteModal={getFavoriteDetails}
                  />
                  <InnerMainContainer id="main">
                    <TitleContainer style={{paddingLeft: programImages?.data?.length===1 && "30px"}}>
                        {program.meta.title}
                    </TitleContainer>
                    
                    <CarouselContainer>
                      {hasPremiumAccess === false ? <>
                          <CarouselMainIcons size="100%" />
                      </> : <ImageCaraousel carouselImages={programImages?.data} />}
                      
                    </CarouselContainer>
                    
                    <HeroContainer>
                      <Hero />
                    </HeroContainer>
                    <NavContainer>
                      <Breadcrumbs isAdmin={isAdmin} isTraveler={isTraveler} programId={programId} />
                      <nav aria-label="Program Brochure Navigation" style={{ width: '50%' }}>
                        <MobileTabs
                          programId={programId}
                          currentTab={currentTab}
                          activeTabs={activeTabs}
                          forTablet
                          isAdmin={isAdmin}
                        />
                      </nav>
                    </NavContainer>
                    <ProgramTabs
                      programId={programId}
                      currentTab={currentTab}
                      activeTabs={activeTabs}
                      isAdmin={isAdmin}
                      isTraveler={isTraveler}
                    />
                    <Component program={program} isAdmin={isAdmin} />
                  </InnerMainContainer>
                </>
              )}
            </MainContainer>
          )}
        </>
      )}
    </>
  );
}

Brochure.propTypes = {
  tab: function(propValue, key, componentName) {
    if (!programBrochureTabs().find(brochureTab => brochureTab.path === (propValue[key] || ''))) {
      history.push(`/not_found`);

      return new Error(
        'Invalid tab `' + propValue[key] + '` supplied to' + ' `' + componentName + '`. Validation failed.',
      );
    }
  },
};
